export class ActiveHarmonicFilter {
    id?: string;
    totalRatedCurrent: number;
    isDisable: boolean = false;

    public constructor (id?: string, totalRateCurrent?: number) {
        this.id = id;
        this.totalRatedCurrent = totalRateCurrent? totalRateCurrent : 0;
    }
}